// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"pt_a bia_i bia_j bia_q bia_vt bia_xl bia_et"};